// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + ({"29":"pirate-ship-gltf-loader","430":"pirate-ship-game","520":"game-map-3d","941":"treasure-island-game"}[chunkId] || chunkId) + "." + {"29":"dd562f81","430":"fe98d658","437":"68ee15d3","489":"bd50a93d","520":"4b5a7af6","560":"33a3351a","870":"ccc728fb","941":"9669cfcf"}[chunkId] + ".js";
};